// DataConfig.LookupThresholdsBands
export enum ThresholdBand {
    POS1 = 1,
    POS2,
    POS3,
    NEG1,
    NEG2,
    NEG3,
}
